import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router'
import { LaskuToimittaja } from '@lemon/core-firebase/model/lasku'
import { FirestoreTosite } from '@lemon/core-firebase/model/tosite'
import { Observable, of as observableOf } from 'rxjs'
import { mergeMap, take } from 'rxjs/operators'
import { FileDropEntry } from '../../_jaettu-angular/file-drop/file-drop-entry'
import { LaskuService } from '../service/lasku/lasku.service'
import { TositeService } from '../service/tosite/tosite.service'

export interface MaksuKatseleComponentData {
  tosite: FirestoreTosite
  tulosta: boolean
}

export interface MaksuKatseleComponentExistingData {
  tosite: FirestoreTosite
}
export interface MaksuLuoUusiComponentData {
  tiedostot: FileDropEntry[]
}

export interface MaksuMuokkaaComponentData {
  tosite: FirestoreTosite
}

@Injectable()
export class MaksuLuoUusiComponentDataResolve implements Resolve<MaksuLuoUusiComponentData> {
  private _existingData: MaksuLuoUusiComponentData = null

  constructor() {}

  asetaOlemassaolevaData(data: MaksuLuoUusiComponentData) {
    this._existingData = data
  }

  resolve(route: ActivatedRouteSnapshot): Observable<MaksuLuoUusiComponentData> {
    return observableOf(this._existingData)
  }
}

@Injectable()
export class MaksuMuokkaaComponentDataResolve implements Resolve<MaksuMuokkaaComponentData> {
  private _existingData: MaksuMuokkaaComponentData = null

  constructor(
    private router: Router,
    private tositeService: TositeService,
  ) {}

  asetaOlemassaolevaData(data: MaksuMuokkaaComponentData) {
    this._existingData = data
  }

  resolve(route: ActivatedRouteSnapshot): Observable<MaksuMuokkaaComponentData> {
    const id = route.params['id']
    if (this._existingData != null && this._existingData.tosite && this._existingData.tosite.avain === id) {
      return observableOf(this._existingData)
    } else {
      return this.tositeService.annaKuittiObservable(id).pipe(
        take(1),
        mergeMap(tosite => {
          if (!tosite) {
            this.router.navigate(['/maksut'])
            return observableOf(null as any as MaksuMuokkaaComponentData)
          }
          const data: MaksuMuokkaaComponentData = { tosite: tosite }
          this.asetaOlemassaolevaData(data)
          return observableOf(data)
        }),
      )
    }
  }
}
@Injectable()
export class MaksuKatseleComponentDataResolve implements Resolve<MaksuKatseleComponentData> {
  private _existingData: MaksuKatseleComponentExistingData = null

  constructor(
    private router: Router,
    private tositeService: TositeService,
  ) {}
  asetaOlemassaolevaData(data: MaksuKatseleComponentExistingData) {
    this._existingData = data
  }

  resolve(route: ActivatedRouteSnapshot): Observable<MaksuKatseleComponentData> {
    const id = route.params['id']
    const toiminto = route.params['toiminto']
    if (this._existingData != null && this._existingData.tosite && this._existingData.tosite.avain === id) {
      const data: MaksuKatseleComponentData = {
        tosite: this._existingData.tosite,
        tulosta: toiminto === 'tulosta',
      }
      return observableOf(data)
    } else {
      return this.tositeService.annaKuittiObservable(id).pipe(
        take(1),
        mergeMap(tosite => {
          if (!tosite) {
            this.router.navigate(['/maksut'])
            return observableOf(null as any as MaksuKatseleComponentData)
          }
          const data: MaksuKatseleComponentData = { tosite: tosite, tulosta: toiminto === 'tulosta' }
          this.asetaOlemassaolevaData(data)
          return observableOf(data)
        }),
      )
    }
  }
}

@Injectable()
export class MaksuToimittajaDataResolve {
  private existingData: LaskuToimittaja = null

  constructor(private laskuService: LaskuService) {}

  asetaOlemassaolevaData(data: LaskuToimittaja) {
    this.existingData = data
  }

  resolve(route: ActivatedRouteSnapshot): Observable<LaskuToimittaja> {
    const id = route.params['id']
    if (id === 'uusi') {
      return this.laskuService.getNewToimittaja().pipe(take(1))
    } else if (this.existingData != null && this.existingData.avain === id) {
      return observableOf(this.existingData)
    } else {
      return this.laskuService.getToimittajaObservable(id).pipe(take(1))
    }
  }
}
